<div class="filter-field">
  <input
    type="text"
    #filterInputBox
    class="filterSearchBox"
    [placeholder]="placeholder"
    [(ngModel)]="filterText"
    tabindex="1">
  <button
    class="btn btn-clear"
    [ngbTooltip]="'clear filter'"
    placement="bottom"
    (click)="clearFilter()"
    tabindex="2">
    <i class="fa fa-times"></i>
  </button>
</div>
